
export function init() {

    if (jQuery(".masonry").length > 0) {
        //console.log("doing masonry for " + jQuery(".masonry").length + " elements");
        jQuery('.masonry').each(function (index, el) {
    
            var thismasonry = jQuery(this);
            
             let itemSelector = thismasonry.attr("data-itemselector");
             let columnWidth = thismasonry.attr("data-columnwidth") || itemSelector;
             let gutterWidth = thismasonry.attr("data-gutter") || 0;

             let percentPosition = thismasonry.data("data-percent");
             percentPosition = (percentPosition == "false") ? false : true;

             let args = {
                itemSelector,
                columnWidth,
                percentPosition,
                gutterWidth
              }

             //console.log("masonry args" , args)

             thismasonry.masonry(args)
            
             thismasonry.on('layoutComplete', function(){console.log("masonry layout complete")});

              
        });
    }
}

